import { shaderMaterial } from '../utils/shaderMaterial.js';

/** Just a random material that only displays UVs */
export class MeshUVMaterial extends shaderMaterial(
  {},
  /* glsl */ `
#define USE_UV

#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )

  varying vec3 vViewPosition;

#endif

#include <common>
#include <uv_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

void main() {

  #include <uv_vertex>

  #include <beginnormal_vertex>
  #include <morphnormal_vertex>
  #include <skinbase_vertex>
  #include <skinnormal_vertex>
  #include <defaultnormal_vertex>
  #include <normal_vertex>

  #include <begin_vertex>
  #include <morphtarget_vertex>
  #include <skinning_vertex>
  #include <project_vertex>
  #include <logdepthbuf_vertex>

#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )

  vViewPosition = - mvPosition.xyz;

#endif

}
`,
  /*glsl */ `
#define USE_UV

uniform float opacity;

#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )

	varying vec3 vViewPosition;

#endif

#include <uv_pars_fragment>

void main() {

  gl_FragColor = vec4( vec3(vUv.xy, 0.0), opacity );

	#ifdef OPAQUE

		gl_FragColor.a = 1.0;

	#endif

}
`
) {}

export default MeshUVMaterial;
